import React from "react";
import { VscVerifiedFilled } from "react-icons/vsc";

const Card1 = ({
  colorFirst,
  colorSecond,
  imageSourceHeader,
  imageSourceLogo,
  imageSourceProfile,
  prefix,
  suffix,
  firstName,
  middleName,
  lastName,
  jobTitle,
  company,
  aboutMe,
  informations,
  maximize = false,
  vcard = null,
  isBadge = false,
}) => {
  return (
    <div className="flex flex-col w-full relative" id="businessCard">
      <div
        className={`flex flex-col bg-white w-full items-start ${
          maximize
            ? "h-[75vh] shadow-[0px_25px_25px_rgba(122,122,122,0.5),0px_-5px_6px_rgba(122,122,122,0.2)]"
            : "max-h-[70vh] shadow-xl"
        } overflow-hidden justify-between relative`}
      >
        <div className="flex flex-col w-full h-full bg-white  overflow-auto pb-20 scrollbar-hide">
          <div className="flex flex-col w-full h-fit justify-start">
            {imageSourceHeader ? (
              <img
                src={imageSourceHeader}
                className="w-full h-[200px] overflow-hidden"
                style={{
                  backgroundColor: colorSecond,
                }}
              />
            ) : (
              <div
                className="w-full h-[200px] overflow-hidden"
                style={{
                  backgroundColor: colorSecond,
                }}
              />
            )}
            <div className="flex flex-row w-full justify-around items-center -mt-[60px]">
              {imageSourceProfile ? (
                <img
                  src={imageSourceProfile}
                  className="flex flex-col h-[130px] w-[130px] bg-white border-white border-4 rounded-full "
                />
              ) : (
                <div className="flex flex-col w-[130px] bg-transparent border-transparent border-4 rounded-full"></div>
              )}
              {imageSourceLogo ? (
                <img
                  src={imageSourceLogo}
                  className="flex flex-col h-[80px] w-[80px] bg-white border-white border-4"
                />
              ) : (
                <div className="flex flex-col h-[80px] w-[80px] bg-transparent border-transparent border-4"></div>
              )}
            </div>
          </div>

          <div className="flex flex-col w-full px-5 items-center gap-4 divide-y-2 divide-secondary mt-5">
            {firstName ||
            middleName ||
            lastName ||
            jobTitle ||
            company ||
            aboutMe ? (
              <div className="flex flex-col w-full items-start">
                {firstName || middleName || lastName ? (
                  <div className="flex flex-row gap-2 items-center text-[22px] font-bold">
                    {(prefix || "") +
                      " " +
                      (firstName || "") +
                      " " +
                      (middleName || "") +
                      " " +
                      (lastName || "") +
                      " " +
                      (suffix || "")}{" "}
                    {isBadge && (
                      <span className="group/verified relative flex text-[24px] justify-center items-center text-primary cursor-pointer">
                        <VscVerifiedFilled />
                        <span className="absolute bottom-full mb-2 hidden group-hover/verified:flex bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
                          Verified account
                        </span>
                      </span>
                    )}
                  </div>
                ) : null}
                {jobTitle || company ? (
                  <div className="text-[14px] text-gray-500">
                    {jobTitle ? jobTitle : "Job Title"}
                    {company ? " at " + company || "" : ""}
                  </div>
                ) : null}
                {aboutMe ? (
                  <div className="text-[14px] mt-3">
                    {aboutMe ? aboutMe : "[About me]"}
                  </div>
                ) : null}
              </div>
            ) : null}
            <div className="flex flex-col w-full items-start pt-4 py-2">
              {informations.map((val, ind) => (
                <a
                  key={ind}
                  className={`flex flex-row gap-2 justify-start items-center w-full text-wrap hover:bg-gray-100 p-2 ${val.lookup_id}-info-slug`}
                  href={val.full_url}
                  target="_blank"
                >
                  <img
                    src={val.image_url}
                    className="w-[40px] p-2 rounded-2xl"
                    style={{ backgroundColor: colorSecond }}
                  />
                  <div
                    className={`w-full truncate rounded ${
                      val.value != "" ? "p-2 cursor-pointer" : ""
                    }`}
                  >
                    {val.value}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
        {maximize && (
          <div className="flex flex-col w-full justify-center items-center absolute bottom-3 bg-transparent py-2">
            <div
              className={`flex flex-col items-center rounded-lg px-12 py-2 text-white text-center cursor-pointer active:translate-y-1 w-fit shadow-lg ${
                maximize ? "animate-bounce" : ""
              }`}
              style={{ backgroundColor: colorFirst }}
              onClick={vcard}
            >
              Add to Contact
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Card1;
